import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    wrapper: 'mb-3',
    header:
      'bg-bg-items-white sm:heading-m-bold heading-s-bold flex w-full cursor-pointer items-center px-5 py-4 text-left md:p-8',
    headerIcon: 'ml-auto',
    content: 'w-full px-5 pt-6 pb-10 md:px-8'
  }
});
